const newsletter = `
# eBL Newsletter 7

## 1 March 2022

### Fragmentarium

#### Photos & Folios

- Photo documentation of Nineveh is now almost entirely complete.
- Addition of folios Lieberman (courtesy N. Veldhuis)
- Addition of folios Smith
- New entries for IM Nimrud tablets; photo documentation will be completed soon

#### Sign List

- LaBaSi is now systematically linked in the sign list
- Snippets of signs are now displayed in the sign list (beta)

#### Image Tagging

- Automatic annotation of images is implemented and waiting to be used

### Corpus

#### Display

- Corpus display is in its final stage of preparation. Score, normalization, and
  translation are already in place.

#### Corpus editor

- It is now possible to add short paragraphs of text in between lines of
  transliteration. Use eBL markup (@i{ }, @bib{ } & etc.) to format your
  explanations, paraphrases of lacking episodes, editorial notes & etc.

### Website launch 🚀

- We strive to open [http://www.ebl.lmu.de](http://www.ebl.lmu.de) to the public
  in April.`

export default newsletter
